import React from 'react'

const AppPadding = ({children}) => {
  return (
    <div  className='px-3'>{children}</div>
  )
}

export default AppPadding